export const ErrorStyle = {
    url: {
        color: '#0099FF !important'
    }
};
